// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["assets/css/includes","assets/css/style"], () => (__webpack_require__("./assets/js/scripts.js")))
__webpack_require__.O(undefined, ["assets/css/includes","assets/css/style"], () => (__webpack_require__("./assets/scss/style.scss")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/css/includes","assets/css/style"], () => (__webpack_require__("./assets/scss/includes.scss")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
